import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import Routes from './routes';
import store from './redux/store';
import appendGoogleAnalyticsTrackingCode from './utils/googleAnalytics';
import appendHotjarTrackingCode from './utils/hotjar';
import './styles/global.scss';

function App() {
  useEffect(() => {
  // Insere o Google Analytics e o Hotjar em Ambiente de Produção
    if (process.env.REACT_APP_ENVIRONMENT === 'Production-BR' || process.env.REACT_APP_ENVIRONMENT === 'Production-EU') {
      appendGoogleAnalyticsTrackingCode();
      appendHotjarTrackingCode();
    }
  }, []);

  return (
    <Provider store={store}>
      <div id="app__container">
        <Routes />
      </div>
    </Provider>
  );
}

export default App;
